import { GET_ALL_PESQUISAS_SATISFACAO, GET_PESQUISA_SATISFACAO_ESPECIFICA, GET_ALL_AUDIOS, GET_PESQUISA_USE } from './mutation-types'

export default {
  [GET_ALL_PESQUISAS_SATISFACAO]: (state, pesquisasSatisfacao) => {
    state.pesquisasSatisfacao = pesquisasSatisfacao
  },
  [GET_PESQUISA_SATISFACAO_ESPECIFICA]: (state, pesquisaSatisfacaoEspecifica) => {
    state.pesquisaSatisfacaoEspecifica = pesquisaSatisfacaoEspecifica
  },
  [GET_PESQUISA_USE]: (state, pesquisaUse) => {
    state.pesquisaUse = pesquisaUse
  },
  [GET_ALL_AUDIOS]: (state, audios) => {
    state.audios = audios
  },
}
